import { render, staticRenderFns } from "./PublicAttachement.vue?vue&type=template&id=1f68f8c6&scoped=true"
import script from "./PublicAttachement.vue?vue&type=script&lang=js"
export * from "./PublicAttachement.vue?vue&type=script&lang=js"
import style0 from "./PublicAttachement.vue?vue&type=style&index=0&id=1f68f8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68f8c6",
  null
  
)

export default component.exports